var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailDeliveryV2Icon = function SvgEmailDeliveryV2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.263.718A1.2 1.2 0 0 0 32.16.5a1 1 0 0 0-.057-.133 2 2 0 0 0-.355-.289l-.194-.072H1.41a1 1 0 0 0-.24 0L.975.079a1 1 0 0 0-.17.12Q.71.27.632.356.6.42.576.49a.97.97 0 0 0-.24.47 1 1 0 0 0 0 .144v21.692c0 .32.12.626.334.852s.505.353.808.353h29.71c.303 0 .594-.127.808-.353a1.24 1.24 0 0 0 .335-.852V1.103a1 1 0 0 0 0-.144 1.3 1.3 0 0 0-.068-.241m-4.434 1.59-11.496 9.328L4.838 2.308zm2.217 19.282H2.62V3.513L15.636 14.07c.2.162.445.25.697.25.253 0 .498-.088.697-.25L30.046 3.513z"
  })));
};
export { SvgEmailDeliveryV2Icon as ReactComponent };